module.exports = "<p>\n  staff-profile works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/staff-profile/staff-profile.component.html
// module id = ./src/app/admin/staff-profile/staff-profile.component.html
// module chunks = main